module.exports = __webpack_public_path__ + "img/29.33eb5368.jpg";